import { motion } from "framer-motion";
import { Slider } from "../ui/slider";
import { CUSTOM_LIMITS } from "../../game/config";

export const CustomSettings = ({ cfg, onChange }) => (
  <motion.div data-testid="custom-settings" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }}
    className="mt-6 grid gap-5 overflow-hidden rounded-3xl border border-sky-400/30 bg-sky-400/5 p-5 backdrop-blur-xl sm:grid-cols-2">
    {Object.entries(CUSTOM_LIMITS).map(([key, { min, max, label }]) => (
      <div key={key}>
        <div className="mb-3 flex items-center justify-between text-sm">
          <span className="font-bold text-white/80">{label}</span>
          <span data-testid={`custom-${key}-value`} className="rounded-lg bg-white/10 px-2 py-0.5 font-display font-black text-sky-300">{cfg[key]}</span>
        </div>
        <Slider data-testid={`custom-${key}-slider`} className="custom-slider" min={min} max={max} step={1} value={[cfg[key]]} onValueChange={([v]) => onChange({ ...cfg, [key]: v })} />
      </div>
    ))}
  </motion.div>
);
